export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14712.1e97a30d.jpg";